<div
  class="loading"
  [ngClass]="{
    'loading--column': messagePosition === 'bottom' && message,
    'loading--row': messagePosition === 'right' && message,
  }"
>
  @if (size === 'small' && color === 'primary') {
    <img
      class="loading__icon"
      [ngClass]="{
        'loading__icon--top': messagePosition === 'bottom' && message,
        'loading__icon--left': messagePosition === 'right' && message,
      }"
      src="assets/img/icons/loading-16.svg"
    />
  }
  @if (size === 'medium' && color === 'primary') {
    <img
      class="loading__icon loading__icon--medium"
      [ngClass]="{
        'loading__icon--top': messagePosition === 'bottom' && message,
        'loading__icon--left': messagePosition === 'right' && message,
      }"
      src="assets/img/icons/loading-24.svg"
    />
  }
  @if (size === 'large' && color === 'primary') {
    <img
      class="loading__icon loading__icon--large"
      [ngClass]="{
        'loading__icon--top': messagePosition === 'bottom' && message,
        'loading__icon--left': messagePosition === 'right' && message,
      }"
      src="assets/img/icons/loading-32.svg"
    />
  }
  @if (size === 'very-large' && color === 'primary') {
    <img
      class="loading__icon loading__icon--very-large"
      [ngClass]="{
        'loading__icon--top': messagePosition === 'bottom' && message,
        'loading__icon--left': messagePosition === 'right' && message,
      }"
      src="assets/img/icons/loading-48.svg"
    />
  }
  @if (size === 'small' && color === 'secondary') {
    <img
      class="loading__icon"
      [ngClass]="{
        'loading__icon--top': messagePosition === 'bottom' && message,
        'loading__icon--left': messagePosition === 'right' && message,
      }"
      src="assets/img/icons/loading-16-gold.svg"
    />
  }
  @if (size === 'medium' && color === 'secondary') {
    <img
      class="loading__icon loading__icon--medium"
      [ngClass]="{
        'loading__icon--top': messagePosition === 'bottom' && message,
        'loading__icon--left': messagePosition === 'right' && message,
      }"
      src="assets/img/icons/loading-24-gold.svg"
    />
  }
  @if (size === 'large' && color === 'secondary') {
    <img
      class="loading__icon loading__icon--large"
      [ngClass]="{
        'loading__icon--top': messagePosition === 'bottom' && message,
        'loading__icon--left': messagePosition === 'right' && message,
      }"
      src="assets/img/icons/loading-32-gold.svg"
    />
  }
  @if (size === 'very-large' && color === 'secondary') {
    <img
      class="loading__icon loading__icon--very-large"
      [ngClass]="{
        'loading__icon--top': messagePosition === 'bottom' && message,
        'loading__icon--left': messagePosition === 'right' && message,
      }"
      src="assets/img/icons/loading-48-gold.svg"
    />
  }
  @if (message) {
    <p
      class="loading__message"
      [ngClass]="{
        'loading__message--small': fontSize === 'small',
      }"
    >
      {{ message }}
    </p>
  }
</div>
